import { Trans } from 'gatsby-plugin-react-i18next';
import React from 'react';

export const ENUM_FIN_FOR_COMP_LEGEND = {
	NOT_EXISTS: 1, // "(puste kółko niebieskie) nie występuje"
	LOT_OF_TIME: 2, // "(pół koła na niebiesko) poświęcisz dużo czasu na to zadanie"
	LOT_OF_TIME_FOR_MANY: 3, // "(całe koło niebieskie) wiele osób w Twojej organizacji poświęci bardzo dużo czasu na to zadanie"
	NONE_OR_NOT_EXISTS: 4, // "(całe koło zielone) brak lub nie występuje"
	OFTEN_EXISTS: 5, // "(pół koła czerwone) czasami występuje"
	ALWAYS_EXISTS: 6, // "(całe koło czerwone) zawsze występuje"
};

export const ENUM_FIN_FOR_COMP_PLAN = {
	0: <Trans i18nKey="pageFinancingForCompany.whyFinteq.card.1.title" />,
	1: <Trans i18nKey="pageFinancingForCompany.whyFinteq.card.2.title" />,
	2: <Trans i18nKey="pageFinancingForCompany.whyFinteq.card.3.title" />,
	3: <Trans i18nKey="pageFinancingForCompany.whyFinteq.card.4.title" />,
	FINTEQ: <Trans i18nKey="pageFinancingForCompany.whyFinteq.card.1.title" />,
	CREDIT: <Trans i18nKey="pageFinancingForCompany.whyFinteq.card.2.title" />,
	FACTORING: <Trans i18nKey="pageFinancingForCompany.whyFinteq.card.3.title" />,
	LOAN: <Trans i18nKey="pageFinancingForCompany.whyFinteq.card.4.title" />,
};
